import $http from '../api/http'

const detection = {
  // 获取任务列表
  async getDetection (data) {
    return $http('/api/detection/pn', {
      method: 'GET',
      params: data
    });
  },
  async detect (data) {
    return $http('/api/detection/pn', {
      method: 'POST',
      data: data
    });
  },
  async export (data) {
    return $http('/api/detection/pn', {
      method: 'GET',
      params: data
    });
  }
};

export default detection;



// WEBPACK FOOTER //
// ./src/api/detection.js